import { render, staticRenderFns } from "./UndergradSchoolForm.vue?vue&type=template&id=01c4ae92&scoped=true&"
import script from "./UndergradSchoolForm.vue?vue&type=script&lang=js&"
export * from "./UndergradSchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./UndergradSchoolForm.vue?vue&type=style&index=0&id=01c4ae92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4ae92",
  null
  
)

component.options.__file = "UndergradSchoolForm.vue"
export default component.exports